import React, { useEffect, useState } from "react";
import "../Styles/CurrentJobs.css";
import { FaMapMarkerAlt, FaClock, FaMoneyBillWave } from "react-icons/fa";
import Navbar from "../components/Navbar";
import defaultLogo from "../assets/logo2.png";
import CurrentJobsregister from "../components/CurrentJobsregister";
const CurrentJobsview = () => {
  const [jobs, setJobs] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);


  /* =============================
     LOAD JOBS FROM LOCAL STORAGE
  ============================== */
  useEffect(() => {
    const hrJobs =
      JSON.parse(localStorage.getItem("AllPostedJobs")) || [];

    const approvedHrJobs = hrJobs.filter(
      (job) => job.admin === "Approved"
    );

    const adminJobs =
      JSON.parse(localStorage.getItem("AdminPostedJobs")) || [];

    const openAdminJobs = adminJobs.filter(
      (job) => job.status === "Open"
    );

    const mergedJobs = [...approvedHrJobs, ...openAdminJobs];

    setJobs(mergedJobs);
  }, []);


  const openPopup = (job) => {
    setSelectedJob(job); // future use after login
    setShowPopup(true);
  };

  const closePopup = () => {
    setSelectedJob(null);
    setShowPopup(false);
  };

  return (
    <>
      <Navbar />
      <br /><br /><br /><br />

      <div className="jobs-section" id="current">
        <div className="jobs-header">
          <h2 className="jobs-title">CURRENT JOBS</h2>
        </div>

        <div className="jobs-grid">
          {jobs.length > 0 ? (
            jobs.map((job, index) => (
              <div key={job.id || index} className="job-card">
                <div className="job-details">


                  <div className="main-hed">
                    <div>
                      <h3>{job.title}</h3>

                      <p className="job-meta">
                        <FaMoneyBillWave className="icon-l" />
                        {job.salaryMin && job.salaryMax
                          ? ` ₹${job.salaryMin} - ₹${job.salaryMax} LPA`
                          : job.stipend || " - "}
                      </p>

                      <p>
                        <strong>Company:</strong>{" "}
                        {job.companyname || job.company || "-"}
                      </p>
                    </div>

                    <div className="job-image-wrapper">
                      <img
                        src={job?.attachment || defaultLogo}
                        alt={job?.title || "Company Logo"}
                        className="job-image"
                      />
                    </div>
                  </div>

                  {/* CONTENT */}
                  <div className="currnt-cont">
                    <div className="m-2">
                      <p>
                        <strong>Skills:</strong>{" "}
                        {Array.isArray(job.skills)
                          ? job.skills.join(", ")
                          : job.skills || "-"}
                      </p>

                      <p>
                        <strong>Qualification:</strong>{" "}
                        {job.qualification || "-"}
                      </p>
                    </div>

                    <div className="m-2 ms-5">
                      <p>
                        <FaMapMarkerAlt className="icon-l" />{" "}
                        {job.location || job.jobLocation || "-"}
                      </p>

                      <p>
                        <FaClock className="icon-l" />{" "}
                        {job.experienceMin
                          ? `${job.experienceMin}-${job.experienceMax} Years`
                          : job.experience || job.exp || "-"}
                      </p>
                    </div>
                  </div>

                  {/* ACTION */}
                  <div className="current-btn">
                    <button
                      className="apply-btn"
                      onClick={() => openPopup(job)}
                    >
                      APPLY NOW
                    </button>
                  </div>

                </div>
              </div>
            ))
          ) : (
            <p className="text-center mt-4">
              No jobs available
            </p>
          )}
        </div>


        {/* LOGIN / MEMBERSHIP POPUP */}
        <CurrentJobsregister
          show={showPopup}
          onClose={closePopup}
          job={selectedJob}
        />
      </div>
    </>
  );
};

export default CurrentJobsview;
